<template>
  <div class="filelist">
    <drag-modal :visible="$store.state.dislog.call" @cancel="close" title='催收记录' width='840px'>
      <Upload :fList='List' @isDisabled="parentHandle" @upFileAfter='lisUpload' v-if='clear != 1' :power='power'
        :call="true" />
      <div class="bot">
        <a-popconfirm :disabled="disabledShow" title="确认提交此条数据吗?" ok-text="确定" cancel-text="取消" @confirm='sub'
          v-if='clear != 1'>
          <a-button :disabled="disabledShow" type="primary" style="margin-right:20px;width:148px;">提交</a-button>
        </a-popconfirm>
        <a-button style='background:#B2C9E1;color:#fff;width:148px;' @click="close">关闭</a-button>
      </div>
    </drag-modal>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import Upload from "@/components/uploads"
import { debtorUrge } from "@/server/debtor"
export default {
  name: "Call",
  props: {
    clear: {
      type: Number,
      default() {
        return 0
      }
    }
  },
  data() {
    return {
      file: [],
      List: [],
      disabledShow: false
    }
  },
  computed: {
    ...mapGetters([
      'debInfo'
    ]),
    power() {
      return {
        edit: this.$common.AccAUTH($store.state.Debinfo.info.accuser.id, "debtor:urge:edit"),
        del: this.$common.AccAUTH($store.state.Debinfo.info.accuser.id, "debtor:urge:del"),
        down: this.$common.AccAUTH($store.state.Debinfo.info.accuser.id, "debtor:urlge:download")
      }
    }
  },
  components: {
    Upload
  },
  created() {
    let file = JSON.parse(JSON.stringify(this.debInfo.urge))
    this.file = file.map(ele => { return ele.upload_id })
    this.List = file
  },
  methods: {
    parentHandle(data) {
      this.disabledShow = data
    },
    lisUpload(fileList) {
      this.file = fileList
    },
    close() {
      this.$store.dispatch('openkey', { key: 'call', by: false })
    },
    sub() {
      if (this.file) {
        debtorUrge({ debtor_id: this.$route.params.id, ids: this.file }).then(e => {
          this.$message.success({ content: '提交成功', key: 'updatable' });
          this.$store.dispatch("Debinfo/getInfo", { id: this.$route.params.id })
          this.close()
        })
      } else {
        this.$message.error("正在上传中，请稍等")
      }
    }
  },
}
</script>
<style lang="less" scoped>
.h2 {
  font-size: 1rem;
  padding-bottom: 20px;
}

.bot {
  text-align: center;
  padding-top: 30px;
}

.input {
  overflow: hidden;
  display: flex;
  margin-bottom: 24px;

  label {
    width: 100px;
    max-width: 100px;
    line-height: 30px;
  }
}
</style>